module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AgentContractView.js"));
	}, "AgentContractView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentContractView!./src/pages/Shop/Member/Agreements/AgentContract/AgentContractView.js
// module id = 944
// module chunks = 438